const useVueStorage = () => {
  const getStorage = (key) => {
    return localStorage.getItem(key);
  };
  const setStorage = (key, data) => {
    localStorage.setItem(key, data);
  };
  const removeStorage = (key) => {
    localStorage.removeItem(key);
  };
  const clearPubilcStorage = () => {
    const list = [
      "device_code",
      "installStatus",
      "source",
      "onlineTime",
      "soft_id",
      "deviceType",
      "ekey",
    ];
    list.forEach((item) => removeStorage(item));
  };

  return { getStorage, setStorage, removeStorage, clearPubilcStorage };
};

export default useVueStorage;
